// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Checkbox as MuiCheckbox } from '@mui/material';
import pxToEm from 'theme/pxToEm';

interface CheckboxProps {
  mbSize: number;
  checkIconColor: string;
  variant: 'square' | 'circle';
  backgroundColor: string;
  hovered: boolean;
  checkBackgroundColor: string;
  hasBorder: boolean;
}

export const Checkbox = styled(MuiCheckbox, {
  shouldForwardProp: (prop) =>
    ![
      'backgroundColor',
      'mbSize',
      'checkIconColor',
      'checkBackgroundColor',
      'hasBorder',
      'hovered',
    ].includes(String(prop)),
})<CheckboxProps>`
  width: ${(props) => pxToEm(props.mbSize)};
  height: ${(props) => pxToEm(props.mbSize)};
  border-radius: ${({ variant }) => (variant === 'square' ? pxToEm(4) : '50%')};
  background: ${({ backgroundColor }) => backgroundColor};
  border: ${({ hasBorder, theme }) =>
    hasBorder && `2px solid ${theme.palette.grey[300]}`};
  opacity: ${({ hovered }) => (hovered ? 1 : 0.5)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transform: translate(0, 0);
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    opacity: 1;
  }

  & > svg {
    display: none;
  }

  &.Mui-checked {
    border: none;
    background-color: ${(props) => props.checkBackgroundColor};
    color: ${(props) => props.checkIconColor};
    opacity: 1;

    & svg {
      display: initial;
      width: 0.5em !important;
    }
  }
`;
